import { Component, OnInit, ViewChild, TemplateRef} from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators } from "@angular/forms";
import { GridOptions, RowNode } from 'ag-grid-community';
import { BsModalService,BsModalRef}   from 'ngx-bootstrap/modal';
import { Clinic } from '../../models/clinic.model';
import { Location } from '../../models/clinic.model';
import { User } from '../../models/user.model';
import { AlertService } from '../../util/alert/alert.service';
import { LocalStorage } from '../../util/localstorage.service'; 
import { CommonFunctions } from '../../util/common-functions';
import { ClinicDataService } from './clinic-data.service';
import { ClinicCustomCellComponent } from './clinic-custom-cell/clinic-custom-cell.component';
import { DatePipe } from '@angular/common';
import { Constants } from '../../util/constants';

@Component({
  selector: 'app-clinic',
  templateUrl: './clinic.component.html',
  styleUrls: ['./clinic.component.scss']
})
export class ClinicComponent implements OnInit {

  public paddingtop: number = 160;
  public iSForm: FormGroup;
  public loggedUser: User
  public clinic:Clinic;
  public location:Location;
  private gridApi: any;
  private gridApiLocation: any;
  private gridColumnApi: any;
  private gridColumnApiLocation: any;
  public columnDefs: any;
  public rowData: any;
  public gridOptions : GridOptions
  public defaultColDef
  public columnDefsLocation: any;
  public rowDataLocation: any;
  public gridOptionsLocation : GridOptions
  public defaultColDefLocation
  public id
  public clinicid
  public clinicname
  public clinicphone
  public clinicwebsite
  public clinicemail
  public clinicfax
  public cliniclogo
  public deletedcliniclogo
  public logoimage
  public fileToUpload
  public image: boolean
  public deletelogo: boolean
  public usercount
  public locationid
  public locationname
  public defaultlocationid
  public defaultclinicphone
  public defaultclinicfax
  public defaultstreetaddress1
  public defaultstreetaddress2
  public defaultcity
  public defaultstate
  public defaultzipcode
  public defaultcountry
  public streetaddress1
  public streetaddress2
  public city
  public state
  public zipcode
  public country
  public bdeleted: boolean
  public hideLocationGrid: boolean
  public valueChanged: boolean
  public clinicLocationList: Array<Location>;
  public adminclinic
  public updateMode 
  public locationupdateMode
  public deleteMode
  public name
  public isAdminUser

  private commonFunctions: CommonFunctions = new CommonFunctions
  @ViewChild('add_edit_Clinic') add_edit_Clinic: TemplateRef<any>
  @ViewChild('add_edit_Clinic_location') add_edit_Clinic_location: TemplateRef<any>
  public ModalRefClinic : BsModalRef 
  public ModalRefLocation : BsModalRef

  constructor(private router: Router, private formBuilder: FormBuilder,private alertService: AlertService,
    private clinicService: ClinicDataService,  private bsModalService :BsModalService) {

    var self = this;
    this.gridOptions = {
      rowData: this.rowData,
      columnDefs: this.columnDefs,
      enableColResize: true,
      enableSorting: true,
	    enableCellTextSelection: true,
      rowSelection: "single",
      rowHeight: 35,
      rowDeselection: true,
      animateRows: true,
      rowBuffer: 20,
      context: {
        componentParent: this
      },
      paginationPageSize: 10
  };

    this.defaultColDef = {
      //autoHeight: true,
      resizable: true,
      filter: true,
    };

    this.columnDefs = [
      { 
        headerName: 'Clinic Id', 
        field: 'clinicid',
        width: 100,
      },
      {
        headerName: 'Clinic Name', 
        field: 'clinicname',
        width: 60,
      },
      { 
        headerName: 'Phone', 
        field: 'defaultclinicphone',
        hide: true
      },
      {
        headerName: 'Clinic Website', 
        field: 'clinicwebsite',
        width: 30,
        hide: true
      },
      { 
        headerName: 'Clinic Fax', 
        field: 'defaultclinicfax',
        width: 30,
        hide: true
      },
      { 
        headerName: 'Clinic Logo', 
        field: 'cliniclogo',
        width: 30,
        hide: true
      },
      { 
        headerName: 'Street Address 1', 
        field: 'defaultstreetaddress1',
        width: 60,
        hide: true
      },
      { 
        headerName: 'Street Address 2', 
        field: 'defaultstreetaddress2',
        width: 60,
        hide: true
      },
      { 
        headerName: 'City', 
        field: 'defaultcity',
        width: 30,
        hide: true
      },
      { 
        headerName: 'State', 
        field: 'defaultstate',
        width: 30,
        hide: true
      },
      { 
        headerName: 'ZipCode', 
        field: 'defaultzipcode',
        width: 30,
		    hide: true
      },
      { 
        headerName: 'Country', 
        field: 'defaultcountry',
        width: 30,
        hide: true
      },
      { 
        headerName: 'Address', 
        field: 'defaultaddress',
        width: 100
      },
      { 
        headerName: 'bAdminClinic', 
        field: 'adminclinic',
        hide: true
      },
      { 
        headerName: '', 
        field: 'edit_delete',
        width: 40,
        cellStyle: {textAlign: "center"},
        cellRendererFramework: ClinicCustomCellComponent,
      } 
    ];

    this.gridOptionsLocation = {
      rowData: this.rowData,
      columnDefs: this.columnDefs,
      enableColResize: true,
      enableSorting: true,
	    enableCellTextSelection: true,
      rowSelection: "single",
      rowHeight: 35,
      rowDeselection: true,
      animateRows: true,
      rowBuffer: 20,
      context: {
        componentParent: this
      },
      paginationPageSize: 10
  };

    this.defaultColDefLocation = {
      //autoHeight: true,
      resizable: true,
      filter: true,
    };

    this.columnDefsLocation = [
      { 
        headerName: 'Location Id', 
        field: 'locationid',
        hide: true
      },
      {
        headerName: 'Clinic Id', 
        field: 'clinicid',
        hide: true
      },
      { 
        headerName: 'Location Name', 
        field: 'locationname',
        width: 30,
      },
      { 
        headerName: 'Phone', 
        field: 'clinicphone',
        width: 25,
      },
      { 
        headerName: 'Clinic Fax', 
        field: 'clinicfax',
        width: 30,
        hide: true
      },
      { 
        headerName: 'Street Address 1', 
        field: 'streetaddress1',
        width: 60,
        hide: true
      },
      { 
        headerName: 'Street Address 2', 
        field: 'streetaddress2',
        width: 60,
        hide: true
      },
      { 
        headerName: 'City', 
        field: 'city',
        width: 30,
        hide: true

      },
      { 
        headerName: 'State', 
        field: 'state',
        width: 30,
        hide: true
      },
      { 
        headerName: 'ZipCode', 
        field: 'zipcode',
        width: 30,
        hide: true
      },
      { 
        headerName: 'Country', 
        field: 'country',
        width: 30,
        hide: true
      } ,
      { 
        headerName: 'Address', 
        field: 'address',
        width: 45,
      },
      { 
        headerName: '', 
        field: 'edit_delete',
        width: 40,
        cellStyle: {textAlign: "center"},
        cellRendererFramework: ClinicCustomCellComponent,
      }
    ];

   }

  ngOnInit(): void {

    this.loggedUser   = JSON.parse(localStorage.getItem(LocalStorage.LOGGED_USER)) as User;
    if(this.loggedUser.UserRoleID == Constants.UserRoleID.AdminUser){
      this.isAdminUser = true
    } else{
      this.isAdminUser = false
    }
    this.iSForm = this.formBuilder.group({
	    name: new FormControl(null),
      clinicname: new FormControl(null),
      clinicphone: new FormControl(null),
      clinicwebsite: new FormControl(null),
      clinicemail: new FormControl(null),
      clinicfax: new FormControl(null),
      cliniclogo: new FormControl(null),
      locationname: new FormControl(null),
      streetaddress1: new FormControl(null),
      streetaddress2: new FormControl(null),
      city: new FormControl(null),
      state: new FormControl(null),
      zipcode: new FormControl(null),
      country: new FormControl(null),
      defaultclinicphone: new FormControl(null),
      defaultclinicfax: new FormControl(null),
      defaultstreetaddress1: new FormControl(null),
      defaultstreetaddress2: new FormControl(null),
      defaultcity: new FormControl(null),
      defaultstate: new FormControl(null),
      defaultzipcode: new FormControl(null),
      defaultcountry: new FormControl(null),
    } ); 

    this.loadData()
  }

  externalFilterChanged() {
    if(this.gridApi != undefined){
      this.gridApi.onFilterChanged();
    }  
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass = (node: RowNode): boolean => {
    var Clinicname = node.data.clinicname.toLowerCase()
    // var Middlename = node.data.middlename.toLowerCase()
    // var Lastname = node.data.lastname.toLowerCase()
    // var Email = node.data.email.toLowerCase()

    if (this.name == null || this.name == undefined || this.name == ""){
      return true
    } else if(Clinicname.includes(this.name.toLowerCase())){
      return true
    } 
    // else if(Middlename.includes(this.name.toLowerCase())){
    //   return true
    // }else if(Lastname.includes(this.name.toLowerCase())){
    //   return true
    // } else if(Email.includes(this.name.toLowerCase())){
    //   return true
    // }
  }

  externalLocationFilterChanged() {
    this.gridApi.onFilterChanged();
  }

  isExternalLocationFilterPresent() {
    return true;
  }

  doesExternalLocationFilterPass = (node: RowNode): boolean => {
    var deleted = node.data.bdeleted

    if(!deleted){
      return true
    }
  }
  
  loadData()
	{
    this.alertService.clear()
    this.valueChanged = false
    this.clinicService.getClinics(this.loggedUser).subscribe(data => this.getData(data))
	}

  public getData(data: any) {
    let clinics: Array<any>=[] 
    data.forEach((element: any) => {
      let clinic: Clinic = element
      clinic.ClinicID = element.ClinicID
      clinic.ClinicName = element.ClinicName
      clinic.ClinicWebsite = element.ClinicWebsite
      clinic.ClinicEmail = element.ClinicEmail
      clinic.ClinicFax = element.ClinicFax
      clinic.ClinicLogo = element.ClinicLogo
      clinic.bAdminClinic = element.bAdminClinic
        clinic.UserCount = element.UserCount
      if(element.LogoImage != null && element.LogoImage != undefined){
        clinic.LogoImage = JSON.stringify(element.LogoImage)
      } else{
        clinic.LogoImage = null
      }

      clinic.Location = element.Location
      let defaultlocation: Location
      clinic.Location.forEach((el: any) => {
        if(el.bDefault == Constants.bDefault.True){
          defaultlocation = el
          defaultlocation.LocationID = el.LocationID
          defaultlocation.LocationName = el.LocationName
          defaultlocation.Phone = el.Phone
          defaultlocation.Fax = el.Fax
          defaultlocation.StreetAddress1 = el.StreetAddress1
          defaultlocation.StreetAddress2 = el.StreetAddress2 
          defaultlocation.City = el.City
          defaultlocation.State = el.State 
          defaultlocation.ZipCode = el.ZipCode 
          defaultlocation.Country = el.Country
          defaultlocation.bDefault = el.bDefault
        }

      });
        
      let Address: String = defaultlocation.StreetAddress1 + " " + defaultlocation.StreetAddress2 + " " + defaultlocation.City + " " +
      defaultlocation.State + " " + defaultlocation.ZipCode + " " + defaultlocation.Country
      
      clinics.push({clinicid: clinic.ClinicID, clinicname: clinic.ClinicName, defaultclinicphone: defaultlocation.Phone, clinicwebsite: clinic.ClinicWebsite ,clinicemail: clinic.ClinicEmail, defaultclinicfax: defaultlocation.Fax, cliniclogo: clinic.ClinicLogo,
        image: clinic.LogoImage, defaultlocationid: defaultlocation.LocationID, defaultstreetaddress1: defaultlocation.StreetAddress1, defaultstreetaddress2: defaultlocation.StreetAddress2, defaultcity: defaultlocation.City, defaultstate: defaultlocation.State, defaultzipcode: defaultlocation.ZipCode, defaultcountry: defaultlocation.Country,
        defaultaddress: Address, adminclinic: clinic.bAdminClinic, usercount: clinic.UserCount, locationdetails: clinic.Location, bdefault: defaultlocation.bDefault})
  
    setTimeout(()=> {
      this.gridApi.forEachNode(node => {
        if ( node.rowIndex  === 0 ){ 
          node.setSelected(true)
          this.clinicid = node.data.clinicid
          this.clinicname = node.data.clinicname
          this.defaultclinicphone = node.data.clinicphone
          this.clinicwebsite = node.data.clinicwebsite
          this.clinicemail = node.data.ClinicEmail
          this.defaultclinicfax = node.data.clinicfax
          this.cliniclogo = node.data.cliniclogo
          if(this.cliniclogo != null && this.cliniclogo != undefined){
            if(this.cliniclogo.split(".")[1] == "jpg"){
            this.logoimage = "data:image/jpg;base64," + JSON.parse(node.data.cliniclogo)
            } else if(this.cliniclogo.split(".")[1] == "png"){
            this.logoimage = "data:image/png;base64," + JSON.parse(node.data.cliniclogo)
            } else if(this.cliniclogo.split(".")[1] == "PNG"){
            this.logoimage = "data:image/PNG;base64," + JSON.parse(node.data.cliniclogo)
            }
          }
          this.defaultstreetaddress1 = node.data.streetsaddress1
          this.defaultstreetaddress2 = node.data.streetaddress2
          this.defaultcity = node.data.city
          this.defaultstate = node.data.state
          this.defaultzipcode = node.data.zipcode
          this.defaultcountry = node.data.country
          this.updateMode = false
          this.deleteMode = false
        } 
      }); 
    
    }, 50); 

    });
    this.rowData = clinics;
    this.initializeClinicDetails();
    return this.rowData;
  }

  initializeClinicDetails()
  {
    this.clinicid = ""
    this.clinicname = ""
    this.defaultclinicphone = ""
    this.clinicwebsite = ""
    this.clinicemail = ""
    this.defaultclinicfax = ""
    this.cliniclogo = ""
    this.deletedcliniclogo = ""
    this.fileToUpload = ""
    this.logoimage = ""
    this.defaultstreetaddress1 = ""
    this.defaultstreetaddress2 = ""
    this.defaultcity = ""
    this.defaultstate = ""
    this.defaultzipcode = ""
    this.defaultcountry = ""
    this.usercount = ""
    this.defaultlocationid = ""
    this.clinicLocationList = []
    this.rowDataLocation = []
    if(this.gridOptionsLocation.api != undefined && this.gridOptionsLocation.api != null){
      this.gridOptionsLocation.api.setRowData(this.rowDataLocation);
    }

    this.image = false
    this.deletelogo = false
    this.updateMode = false 
    this.deleteMode = false 
    this.hideLocationGrid = true
    this.locationupdateMode = true
  }

  initializeLocationDetails()
  {
    this.locationid = ""
    this.locationname = ""
    this.clinicphone = ""
    this.clinicfax = ""
    this.streetaddress1 = ""
    this.streetaddress2 = ""
    this.city = ""
    this.state = ""
    this.zipcode = ""
    this.country = ""
    this.bdeleted = Constants.bDeleted.False
    this.locationupdateMode = false
  }

  cancelBtnClickEvent(){
    this.name = null
    this.externalFilterChanged()
  }
  

  // exitBtnClickEvent(){ 
  //   this.router.navigateByUrl('landing'); 
  // }

  searchBtnClickEvent(){
    this.alertService.clear()
    this.externalFilterChanged()
  }

  editLocation(data: any){
    this.locationid = data.locationid
    this.locationname = data.locationname
    this.clinicphone = data.clinicphone
    this.clinicfax = data.clinicfax
    this.streetaddress1 = data.streetaddress1
    this.streetaddress2 = data.streetaddress2
    this.city = data.city
    this.state = data.state
    this.zipcode = data.zipcode
    this.country = data.country
    this.locationupdateMode = true
    this.ModalRefLocation = this.bsModalService.show(this.add_edit_Clinic_location)
  }

  editClinic(data: any){
    this.alertService.clear()
    this.initializeClinicDetails()
    this.ModalRefClinic = this.bsModalService.show(this.add_edit_Clinic)
    this.clinicid = data.clinicid
    this.clinicname = data.clinicname
    this.defaultclinicphone = data.defaultclinicphone
    this.clinicwebsite = data.clinicwebsite
    this.clinicemail = data.clinicemail
    this.defaultclinicfax = data.defaultclinicfax
    this.cliniclogo = data.cliniclogo
    if(data.image != null && data.image != undefined){
		if(this.cliniclogo != null && this.cliniclogo != undefined){
		  if(this.cliniclogo.split(".")[1] == "jpg"){
			this.logoimage = "data:image/jpg;base64," + JSON.parse(data.image)
		  } else if(this.cliniclogo.split(".")[1] == "png"){
			this.logoimage = "data:image/png;base64," + JSON.parse(data.image)
		  } else if(this.cliniclogo.split(".")[1] == "PNG"){
			this.logoimage = "data:image/PNG;base64," + JSON.parse(data.image)
		  }
		}
      this.image = true
    } else{
      this.logoimage = ""
      this.image = false
    }
    this.deletelogo = false
    this.defaultlocationid = data.defaultlocationid
    this.defaultstreetaddress1 = data.defaultstreetaddress1
    this.defaultstreetaddress2 = data.defaultstreetaddress2
    this.defaultcity = data.defaultcity
    this.defaultstate = data.defaultstate
    this.defaultzipcode = data.defaultzipcode
    this.defaultcountry = data.defaultcountry

    this.rowDataLocation = []
    if(data.locationdetails != null && data.locationdetails != undefined){
      setTimeout(()=> {
      data.locationdetails.forEach((el: any) => {
        let locationdetails: Location = el
        if(el.bDefault != Constants.bDefault.True){
          locationdetails.LocationID = el.LocationID
          locationdetails.LocationName = el.LocationName
          locationdetails.Phone = el.Phone
          locationdetails.Fax = el.Fax
          locationdetails.StreetAddress1 = el.StreetAddress1
          locationdetails.StreetAddress2 = el.StreetAddress2 
          locationdetails.City = el.City
          locationdetails.State = el.State 
          locationdetails.ZipCode = el.ZipCode 
          locationdetails.Country = el.Country
          locationdetails.bDefault = el.bDefault

          let Address: String = locationdetails.StreetAddress1 + " " + locationdetails.StreetAddress2 + " " + locationdetails.City + " " +
          locationdetails.State + " " + locationdetails.ZipCode + " " + locationdetails.Country
  
          this.rowDataLocation.push({locationid: locationdetails.LocationID, locationname: locationdetails.LocationName, clinicphone: locationdetails.Phone,clinicfax: locationdetails.Fax, streetaddress1: locationdetails.StreetAddress1, 
            streetaddress2: locationdetails.StreetAddress2, city: locationdetails.City, state: locationdetails.State, zipcode: locationdetails.ZipCode, country: locationdetails.Country, address: Address, bdefault: locationdetails.bDefault, bdeleted: Constants.bDeleted.False}) 
          if(this.gridOptionsLocation.api != undefined && this.gridOptionsLocation.api != null){
            this.gridOptionsLocation.api.setRowData(this.rowDataLocation);
            this.hideLocationGrid = false
          }
        }

        });
      }, 50);
    } 
    this.updateMode = true
  }

  deleteLocation(data: any){
    this.alertService.clear()
    if(confirm("Are you sure you want to delete selected record?")){
      this.locationid = data.locationid
      this.locationname = data.locationname
      this.clinicphone = data.clinicphone
      this.clinicfax = data.clinicfax
      this.streetaddress1 = data.streetaddress1
      this.streetaddress2 = data.streetaddress2
      this.city = data.city
      this.state = data.state
      this.zipcode = data.zipcode
      this.country = data.country
      this.bdeleted = Constants.bDeleted.True
      this.saveLocationDetails()
    }
  }

  deleteClinic(data: any){
    this.alertService.clear()
    this.initializeClinicDetails()

    var confirm1
    var confirm2

    if(Number(data.usercount) > 0){
      confirm2 = confirm("If you delete " + data.clinicname + ", users attached to the clinic will not be able to access the system. Are you sure you want to delete? ")
    } else{
      confirm1 = confirm("Are you sure you want to delete selected record?")
    }
    
    
    if (confirm1 || confirm2) { 
      this.clinicid = data.clinicid
      this.clinicname = data.clinicname
      this.defaultclinicphone = data.clinicphone
      this.clinicwebsite = data.clinicwebsite
      this.clinicemail = data.clinicemail
      this.defaultclinicfax = data.clinicfax
      this.cliniclogo = data.cliniclogo
      this.deletelogo = false
      this.defaultstreetaddress1 = data.streetaddress1
      this.defaultstreetaddress2 = data.streetaddress2
      this.defaultcity = data.city
      this.defaultstate = data.state
      this.defaultzipcode = data.zipcode
      this.defaultcountry = data.country
      this.adminclinic = data.adminclinic
	    this.usercount = data.usercount

      this.deleteMode = true
      this.saveClinicDetails()
    }
  }

  addnewclinic(){
    this.alertService.clear()
    this.initializeClinicDetails()
    this.ModalRefClinic = this.bsModalService.show(this.add_edit_Clinic)
  }

  addClinicLocation(){
    this.alertService.clear()
    this.initializeLocationDetails()
    this.ModalRefLocation = this.bsModalService.show(this.add_edit_Clinic_location)
  }

  validateClinic():boolean
  { 
    if(!this.deleteMode){
        if ((this.iSForm.controls.clinicname.value == ""  || 
        this.iSForm.controls.clinicname.value == null ))
        { 
          this.alertService.clear()
          this.alertService.error('Invalid Clinic Name')
          return false
        } else{
          var i
          if(!this.updateMode){
            for(i = 0; i < this.rowData.length; i++){
              if(this.iSForm.controls.clinicname.value == this.rowData[i].clinicname){
                this.alertService.clear()
                this.alertService.error('Clinic Name already exists')
                return false           
              }
            }
          }else{
            for(i = 0; i < this.rowData.length; i++){
              if((this.iSForm.controls.clinicname.value == this.rowData[i].clinicname) && (this.rowData[i].clinicid != this.clinicid)){
                this.alertService.clear()
                this.alertService.error('Clinic Name already exists')
                return false           
              }
            }
          }
        }
        var phoneVal = /^\s*(?:\+?(\d{1,3}))?[- (]*(\d{3})[- )]*(\d{3})[- ]*(\d{4})(?: *[x/#]{1}(\d+))?\s*$/;
        if (this.iSForm.controls.defaultclinicphone.value != null && this.iSForm.controls.defaultclinicphone.value != "") {
          if(!(phoneVal.test(this.iSForm.controls.defaultclinicphone.value))){
            this.alertService.clear()
            this.alertService.error('Invalid Phone Number')
            return false
          }
        }   
        var emailVal = /\S+@\S+\.\S+/;
        if (this.iSForm.controls.clinicemail.value != null && this.iSForm.controls.clinicemail.value != "") {
          if(!(emailVal.test(this.iSForm.controls.clinicemail.value))){
            this.alertService.clear()
            this.alertService.error('Invalid Email')
            return false
          }
        } 
    } else{
      if (this.adminclinic == Constants.Clinic.AdminClinic ){ 
          this.alertService.clear()
          this.alertService.error('Cannot delete the admin clinic')
          return false
      }
    }
    return true
  }

  validateLocation():boolean
  { 
    if(!this.bdeleted){
      if ((this.iSForm.controls.locationname.value == ""  || 
        this.iSForm.controls.locationname.value == null ))
      { 
        this.alertService.clear()
        this.alertService.error('Invalid Location Name')
        return false
      }  
      var phoneVal = /^\s*(?:\+?(\d{1,3}))?[- (]*(\d{3})[- )]*(\d{3})[- ]*(\d{4})(?: *[x/#]{1}(\d+))?\s*$/;
      if (this.iSForm.controls.clinicphone.value != null && this.iSForm.controls.clinicphone.value != "") {
        if(!(phoneVal.test(this.iSForm.controls.clinicphone.value))){
          this.alertService.clear()
          this.alertService.error('Invalid Phone Number')
          return false
        }
      }   
      return true
    } else{
      return true
    }
  }

  deleteLogo(){
    this.image = false
    this.deletelogo = true
    this.valueChanged = true
    this.fileToUpload = null
    this.deletedcliniclogo = this.cliniclogo
    this.cliniclogo = ""
  }

  handleFileInput(event: any) {
    this.fileToUpload = null
      let data: any
      data = event.target.files[0];
    if(data != null && data != undefined){
      this.fileToUpload = data
      var reader = new FileReader();
      reader.readAsDataURL(data); // read file as data url
      reader.onload = (e) => { // called once readAsDataURL is completed
        this.logoimage = (<FileReader>e.target).result
        this.image = true
      }
      this.valueChanged = true
    }
  }

  saveLocationDetails(){
    if(this.validateLocation()){
      this.alertService.clear()
      let locationid
      if(this.locationid != null && this.locationid != "" && this.locationid != undefined){
        locationid = this.locationid
        this.rowDataLocation.forEach((element: any) =>{
          if(element.locationid == locationid){
            this.rowDataLocation.splice(this.rowDataLocation.indexOf(element),1)
          }
        })
      } else{
        locationid = this.commonFunctions.getnewguid()
        this.bdeleted = Constants.bDeleted.False
      }
      
      let Address: String = this.streetaddress1 + " " + this.streetaddress2 + " " + this.city + " " +
      this.state + " " + this.zipcode + " " + this.country

      this.rowDataLocation.push({locationid: locationid, locationname: this.locationname, clinicphone: this.clinicphone,clinicfax: this.clinicfax, streetaddress1: this.streetaddress1, 
        streetaddress2: this.streetaddress2, city: this.city, state: this.state, zipcode: this.zipcode, country: this.country, address: Address, bdefault: Constants.bDefault.False, bdeleted: this.bdeleted})
      this.gridOptionsLocation.api.setRowData(this.rowDataLocation);
      if(this.ModalRefLocation){
        this.ModalRefLocation.hide()
      }
      this.hideLocationGrid = false
      this.valueChanged = true
      this.initializeLocationDetails()
      this.externalFilterChanged()
    }
  }

  createClinicLocationDetails(clinicid){
    this.clinicLocationList = []

    //default location
    this.location = new Location()
    if(this.defaultlocationid == "" || this.defaultlocationid == null || this.defaultlocationid == undefined){
      this.location.LocationID = this.commonFunctions.getnewguid() 
    } else{
      this.location.LocationID =  this.defaultlocationid
    }
    this.location.ClinicID = clinicid
    this.location.LocationName = Constants.DefaultValues.LocationName
    this.location.Phone = this.defaultclinicphone
    this.location.Fax = this.defaultclinicfax
    this.location.StreetAddress1 = this.defaultstreetaddress1
    this.location.StreetAddress2 = this.defaultstreetaddress2 
    this.location.City = this.defaultcity
    this.location.State = this.defaultstate 
    this.location.ZipCode = this.defaultzipcode 
    this.location.Country = this.defaultcountry
    this.location.bDefault = true
    this.clinicLocationList.push(this.location)

    if(this.rowDataLocation != null &&  this.rowDataLocation != undefined){
        this.gridApiLocation.forEachNode(node => {
          this.location = new Location()
          this.location.LocationID = node.data.locationid
          this.location.ClinicID = clinicid
          this.location.LocationName = node.data.locationname
          this.location.Phone = node.data.clinicphone
          this.location.Fax = node.data.clinicfax
          this.location.StreetAddress1 = node.data.streetaddress1
          this.location.StreetAddress2 = node.data.streetaddress2 
          this.location.City = node.data.city
          this.location.State = node.data.state 
          this.location.ZipCode = node.data.zipcode 
          this.location.Country = node.data.country
          this.location.bDefault = false
          if(node.data.bdeleted){
            this.location.bDeleted = Constants.bDeleted.True
            this.location.DeletedBy = this.loggedUser.UserID
            this.location.DeletedOn = new Date()
          } else{
            this.location.bDeleted = Constants.bDeleted.False
          }
          this.clinicLocationList.push(this.location)
          return this.clinicLocationList
        }); 
    }
  }

  saveClinicDetails(){
    if (this.validateClinic()){
      this.clinic = new Clinic()
      if(this.clinicid == ""){
        this.clinic.ClinicID =  this.commonFunctions.getnewguid() 
      } else{
        this.clinic.ClinicID =  this.clinicid
      }
      this.clinic.ClinicName = this.clinicname
      this.clinic.ClinicWebsite = this.clinicwebsite
      this.clinic.ClinicEmail = this.clinicemail
      if(this.deletedcliniclogo != null && this.deletedcliniclogo != "" && this.deletedcliniclogo != undefined){
        this.clinic.ClinicLogo = this.deletedcliniclogo
      } else{
        this.clinic.ClinicLogo = this.cliniclogo
      }
      this.clinic.bDeleteLogo = this.deletelogo    

      if(this.deleteMode)
      {
        this.clinic.bDeleted = Constants.bDeleted.True
        this.clinic.DeletedBy = this.loggedUser.UserID
        this.clinic.DeletedOn = new Date()
      } else{
        this.clinic.bDeleted = Constants.bDeleted.False
        //create clinic location details
        this.createClinicLocationDetails(this.clinic.ClinicID);
      }
      setTimeout(()=> {
      if(this.clinicLocationList != null && this.clinicLocationList != undefined){
          this.clinic.Location = this.clinicLocationList
      } else{
          this.clinic.Location = []
      }

      const clinicdata: FormData = new FormData();
      if(this.fileToUpload != null && this.fileToUpload != undefined && this.fileToUpload != ""){
        clinicdata.append("fileUpload", this.fileToUpload);
      } else{
        
        clinicdata.append("fileUpload", "No File");
      }
      clinicdata.append("clinic", JSON.stringify(this.clinic));
      this.clinicService.saveClinic(clinicdata, this.loggedUser).subscribe(date =>
      {
        this.alertService.clear()
        this.loadData()
        if(this.updateMode && !this.deleteMode){
          this.alertService.success('Successfully updated')
        } else if(this.deleteMode){
          this.alertService.success('Successfully deleted')
        } else{
          this.alertService.success('Successfully saved')
        }
        this.cancelModal()
        
      },
      error => { 
        this.alertService.clear()
        //this.loadData()
        this.alertService.error('Error occured while saving data')
          
       });

      }, 50);
    }
    
  }

  changeValue(){
    this.valueChanged = true
  }

  cancelModal(){
    if(this.valueChanged){
      if(confirm("There are unsaved changes, are you sure you want to cancel?")){
        this.ModalRefClinic.hide()
        this.loadData()
      }
    } else{
      this.ModalRefClinic.hide()
    }
    
  }

  cancelModalLocation(){
    this.ModalRefLocation.hide()
    this.initializeLocationDetails()
  }

  gridSizeChanged(params: any) {
		params.api.sizeColumnsToFit();
  }

  onGridReady(params: any) { 
    this.rowData = []
		this.gridApi  = params.api;
    this.gridColumnApi = params.columnApi; 
    this.gridApi.sizeColumnsToFit();
  }

  onGridReadyLocation(params: any) { 
    this.rowDataLocation = []
		this.gridApiLocation  = params.api;
    this.gridColumnApiLocation = params.columnApi;
    this.gridApiLocation.sizeColumnsToFit();
  }

}
